export default {
  namespaced: true,
  state: {
    model: null,
    loading: false,
  },
  getters: {
    logo: (state, getters) => {
      if (getters.organization) return getters.organization.logo
    },
    model: state => state.model,
    name: (state, getters) => {
      if (!getters.organization) return

      return getters.organization
        ? getters.organization.name
        : getters.model.opportunity.name
    },
    organization: state => {
      if (!state.model) return

      return state.model.organization
        ? state.model.organization
        : state.model.opportunity.organization
    },
    loading: state => state.loading,
  },
  mutations: {
    set(state, profile) {
      state.model = profile
    },
    setLoading(state, loadingState) {
      state.loading = loadingState
    },
  },
  actions: {
    fetch({ commit }, slug) {
      commit('setLoading', true)
      return Vue.$http.get(`campaigns/${slug}`).then(({ data }) => {
        commit('set', data)
        commit('setLoading', false)
      })
    },
  },
}
